(function () {
    "use strict";

    function getAddToCartButton() {
        return document.querySelector('.product-info__add-to-cart button[type="submit"]');
    }

    function getStickyAtcButton() {
        return document.querySelector('.convx__sticky-atc-button');
    }

    function getKlaviyoBisTrigger() {
        return document.querySelector('#Klaviyo_button');
    }

    function isKlaviyoBisAvailable() {
        if (!getKlaviyoBisTrigger() || !window.__kcKlaviyoBisConfig) return false;

        const productRoot = document.querySelector('.product.js-product');
        const tags = (productRoot?.dataset.kcProductTags || '').split('|').filter(Boolean);
        return !tags.includes('Not_showing_notify_me');
    }

    function isSoldOutButton(addToCartButton) {
        return (
            addToCartButton.disabled ||
            addToCartButton.classList.contains('sold-out') ||
            addToCartButton.value === 'sold_out' ||
            addToCartButton.textContent.trim().toLowerCase().includes('sold out') ||
            addToCartButton.textContent.trim().toLowerCase().includes('no stock')
        );
    }

    function setBuyNowHidden(buyNowButton, hidden) {
        if (!buyNowButton) return;
        const form = buyNowButton.closest('form');

        if (hidden) {
            buyNowButton.hidden = true;
            buyNowButton.disabled = true;
            buyNowButton.style.display = 'none';
            buyNowButton.setAttribute('aria-hidden', 'true');
            if (form?.classList.contains('product-info__buy-now-form')) {
                form.hidden = true;
            }
        } else {
            buyNowButton.hidden = false;
            buyNowButton.disabled = false;
            buyNowButton.style.display = '';
            buyNowButton.setAttribute('aria-hidden', 'false');
            if (form?.classList.contains('product-info__buy-now-form')) {
                form.hidden = false;
            }
        }
    }

    function syncStickyButtonState(addToCartButton, stickyAtcButton) {
        const buyNowButtons = document.querySelectorAll('.buy-now-form .btn');
        const isSoldOut = isSoldOutButton(addToCartButton);

        stickyAtcButton.classList.remove(
            'convx__sticky-atc-button--sold-out',
            'convx__sticky-atc-button--notify'
        );

        if (isSoldOut) {
            buyNowButtons.forEach((buyNowButton) => {
                const form = buyNowButton.closest('form');
                if (form?.classList.contains('convx__section-3-checkout-form')) return;
                setBuyNowHidden(buyNowButton, true);
            });

            if (isKlaviyoBisAvailable()) {
                stickyAtcButton.disabled = false;
                stickyAtcButton.textContent = 'Notify Me';
                stickyAtcButton.classList.add('convx__sticky-atc-button--notify');
            } else {
                stickyAtcButton.disabled = true;
                stickyAtcButton.textContent = 'Sold Out';
                stickyAtcButton.classList.add('convx__sticky-atc-button--sold-out');
            }
        } else {
            stickyAtcButton.disabled = false;
            stickyAtcButton.textContent = 'Add to Cart';
            buyNowButtons.forEach((buyNowButton) => {
                const form = buyNowButton.closest('form');
                if (form?.classList.contains('convx__section-3-checkout-form')) return;
                setBuyNowHidden(buyNowButton, false);
            });
        }
    }

    function syncStickyPriceFromMain() {
        const stickyPrice = document.querySelector('.convx__sticky-atc-panel .product-info__price');
        const mainPrice = document.querySelector('.product-price [data-dynamic-variant-content$="-price"]')
            || document.querySelector('.product-info__block.product-price .product-info__price');
        if (!stickyPrice || !mainPrice) return;
        stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    function getMainVariantInput() {
        return document.querySelector('.js-product-form-main input[name="id"]')
            || document.querySelector('.product.js-product .js-product-form input[name="id"]:not(.buy-now-form input)');
    }

    function syncAllBuyNowVariantIdsFromMain() {
        const mainVariantInput = getMainVariantInput();
        if (!mainVariantInput?.value) return;

        document.querySelectorAll('.buy-now-form input[name="id"]').forEach((input) => {
            const form = input.closest('form');
            if (form?.classList.contains('convx__section-3-checkout-form')) return;

            if (input.value !== mainVariantInput.value) {
                input.value = mainVariantInput.value;
            }
        });

        const variant = document.querySelector('variant-picker')?.variant;
        if (variant) {
            document.querySelectorAll('.convx__section-3-checkout-btn').forEach((button) => {
                button.disabled = !variant.available;
            });
        }
    }

    function syncStickyVariantIdFromMain() {
        syncAllBuyNowVariantIdsFromMain();
    }

    function syncInlineBuyNowVisibility(addToCartButton) {
        if (!addToCartButton) return;

        const isSoldOut = isSoldOutButton(addToCartButton);
        document.querySelectorAll('.product-info__buy-now-form .btn, .product-info__buy-now-button').forEach((buyNowButton) => {
            setBuyNowHidden(buyNowButton, isSoldOut);
        });
    }

    function syncBuyNowFormsOnProductPage() {
        syncAllBuyNowVariantIdsFromMain();
        syncStickyPriceFromMain();

        const addToCartButton = getAddToCartButton();
        const stickyAtcButton = getStickyAtcButton();
        if (addToCartButton && stickyAtcButton) {
            syncStickyButtonState(addToCartButton, stickyAtcButton);
        } else if (addToCartButton) {
            syncInlineBuyNowVisibility(addToCartButton);
        }
    }

    function triggerKlaviyoBis() {
        const trigger = getKlaviyoBisTrigger();
        if (!trigger) return;
        trigger.click();
    }

    function showBuyNowButton() {
        const buyNowButtons = document.querySelectorAll('.buy-now-form');
        const stickyPanel = document.querySelector('.convx__sticky-atc-panel');
        const addToCartButton = getAddToCartButton();

        buyNowButtons.forEach((form) => {
            if (form.classList.contains('convx__section-3-checkout-form')) return;

            const button = form.querySelector('.btn');
            if (button) {
                button.type = 'submit';
            }

            form.addEventListener('submit', () => {
                syncAllBuyNowVariantIdsFromMain();
            }, { capture: true });
        });

        syncBuyNowFormsOnProductPage();

        document.addEventListener('on:variant:change', () => {
            setTimeout(syncBuyNowFormsOnProductPage, 20);
        });

        document.addEventListener('kc:klaviyo-bis:update', syncBuyNowFormsOnProductPage);

        if (!stickyPanel || !addToCartButton) return;

        const mutationObserver = new MutationObserver(syncBuyNowFormsOnProductPage);
        mutationObserver.observe(addToCartButton, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
        });

        stickyPanel.addEventListener('click', (event) => {
            const stickyAtcButton = event.target.closest('.convx__sticky-atc-button');
            if (!stickyAtcButton) return;

            event.preventDefault();

            if (stickyAtcButton.classList.contains('convx__sticky-atc-button--notify')) {
                triggerKlaviyoBis();
                return;
            }

            if (!stickyAtcButton.disabled) {
                getAddToCartButton()?.click();
            }
        });

        const hideOnButtonVisible = stickyPanel.hasAttribute('data-hide-on-button-visible');
        if (!hideOnButtonVisible) {
            stickyPanel.classList.remove('hide');
            stickyPanel.classList.add('show');
            return;
        }

        const intersectionObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    stickyPanel.classList.remove('show');
                    stickyPanel.classList.add('hide');
                } else {
                    stickyPanel.classList.remove('hide');
                    stickyPanel.classList.add('show');
                }
            },
            { root: null, threshold: 0 }
        );

        stickyPanel.classList.add('hide');
        intersectionObserver.observe(addToCartButton);
    }

    function onDOMContentLoaded() {
        if (location.pathname.includes('/products')) {
            window.__kcSyncBuyNowVariants = syncAllBuyNowVariantIdsFromMain;
            showBuyNowButton();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onDOMContentLoaded, { once: true });
    } else {
        onDOMContentLoaded();
    }
})();
